import { renderNetworkTagNodes } from '@Compute/utils/secgroupDisplay'
import { PROVIDER_MAP } from '@/constants'
import BrandIcon from '@/sections/BrandIcon'
import i18n from '@/locales'
import { getServerConf } from '../utils'

/** 容器主机（server_container）工单资源详情展示，字段参考 vminstance-container/sidepage/Detail */
export default {
  methods: {
    initServerContainerInfo () {
      const containerInfo = [
        {
          title: i18n.t('common_385'),
          items: [
            {
              field: 'name',
              title: i18n.t('common_186'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return serverConf.generate_name || serverConf.name || '-'
              },
            },
            {
              field: 'resource_type',
              title: i18n.t('common.resource_type'),
              formatter: () => {
                return i18n.te('dictionary.server_container') ? i18n.t('dictionary.server_container') : 'server_container'
              },
            },
            {
              field: 'project',
              title: i18n.t('table.title.owner_project'),
              formatter: () => {
                const v = this.variables
                const domain = v.project_domain
                const project = v.project_name || v.project
                if (!project) return '-'
                return `${domain}/${project}`
              },
            },
            {
              field: 'region',
              title: i18n.t('common_282'),
              formatter: ({ row }) => this.formatRegionZone(row),
            },
            {
              field: 'hypervisor',
              title: i18n.t('common_283'),
              slots: {
                default: ({ row }) => {
                  const serverConf = getServerConf(row)
                  let brand = ''
                  if (serverConf.provider) {
                    brand = PROVIDER_MAP[serverConf.provider]?.brand || serverConf.provider
                  }
                  if (!brand) {
                    const formType = serverConf.extraData?.formType
                    if (formType === 'private') brand = 'Cloudpods'
                    else if (formType === 'onpremise' || formType === 'idc') brand = 'OneCloud'
                  }
                  if (!brand) return '-'
                  return [<BrandIcon name={brand} />]
                },
              },
            },
            {
              field: 'config',
              title: i18n.t('common_428'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const cpu = serverConf.vcpu_count || (row.skuInfo && row.skuInfo.cpu_core_count)
                const memory = serverConf.vmem_size || (row.skuInfo && row.skuInfo.memory_size_mb)
                let ret = (cpu || '-') + i18n.t('common_429') + ((memory / 1024) || '-') + 'GB'
                if (row.skuInfo && row.skuInfo.instance_type_category) {
                  const type = this.getI18NValue(`skuCategoryOptions['${this.detailsData.hypervisor}']['${row.skuInfo.instance_type_category}']`, row.skuInfo.instance_type_category)
                  ret += `（${row.skuInfo.name || ''} ${type}）`
                }
                return ret
              },
            },
            {
              field: 'count',
              title: i18n.t('common_430'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return (serverConf.__count__ || 1) + i18n.t('common_431')
              },
            },
            {
              field: 'os_arch',
              title: 'OS_ARCH',
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return serverConf.os_arch || row.os_arch || '-'
              },
            },
            {
              field: 'vcpu_count',
              title: 'CPU',
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const cpu = serverConf.vcpu_count || (row.skuInfo && row.skuInfo.cpu_core_count)
                if (!cpu) return '-'
                return cpu + this.$t('compute.text_167')
              },
            },
            {
              field: 'vmem_size',
              title: this.$t('compute.text_369'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const memory = serverConf.vmem_size || (row.skuInfo && row.skuInfo.memory_size_mb)
                if (!memory) return '-'
                return (memory / 1024) + 'GB'
              },
            },
            {
              field: 'dataDisk',
              title: this.$t('compute.text_50'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                return this.getDiskInfo(row, serverConf).dataDisk || '-'
              },
            },
            {
              field: 'isolated_devices',
              title: this.$t('compute.text_113'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                if (!serverConf.isolated_devices?.length) return '-'
                const devices = serverConf.isolated_devices.filter(val => val.dev_type !== 'USB')
                if (!devices.length) return '-'
                const gpu = {}
                devices.forEach((item) => {
                  const key = item.model || `${item.vendor}/${item.model}`
                  gpu[key] = (gpu[key] || 0) + 1
                })
                return Object.keys(gpu).map(k => this.$t('compute.text_370', [gpu[k], k])).join('、') || '-'
              },
            },
            {
              field: 'network',
              title: i18n.t('compute.text_104'),
              slots: {
                default: () => this.renderWorkflowNetworkInfo(),
              },
            },
            {
              field: 'eip',
              title: this.$t('compute.text_1374'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                if (serverConf.eip) return serverConf.eip
                if (serverConf.eip_charge_type) {
                  return `${this.$t('compute.text_1375')}: ${serverConf.eip_bgp_type ? (this.$te(`bgpTypes.${serverConf.eip_bgp_type}`) ? this.$t(`bgpTypes.${serverConf.eip_bgp_type}`) : serverConf.eip_bgp_type) : ''} ${this.$te(`chargeTypes.${serverConf.eip_charge_type}`) ? this.$t(`chargeTypes.${serverConf.eip_charge_type}`) : serverConf.eip_charge_type} ${serverConf.eip_bw} Mbps`
                }
                if (serverConf.public_ip_charge_type) {
                  return `${this.$t('compute.text_1375')}: ${serverConf.eip_bgp_type ? (this.$te(`bgpTypes.${serverConf.eip_bgp_type}`) ? this.$t(`bgpTypes.${serverConf.eip_bgp_type}`) : serverConf.eip_bgp_type) : ''} ${this.$te(`chargeTypes.${serverConf.public_ip_charge_type}`) ? this.$t(`chargeTypes.${serverConf.public_ip_charge_type}`) : serverConf.public_ip_charge_type} ${serverConf.public_ip_bw} Mbps`
                }
                return '-'
              },
            },
            {
              field: 'secgroups',
              title: i18n.t('compute.text_105'),
              slots: {
                default: ({ row }) => {
                  if (row.networkTags && row.networkTags.length) {
                    return renderNetworkTagNodes(row.networkTags)
                  }
                  const ret = []
                  if (row.secgroupInfo && row.secgroupInfo.data && row.secgroupInfo.data.length) {
                    row.secgroupInfo.data.forEach(item => {
                      ret.push(<div>{item.name}</div>)
                    })
                  }
                  return ret.length ? ret : '-'
                },
              },
            },
            {
              field: 'schedtags',
              title: i18n.t('compute.text_311'),
              slots: {
                default: ({ row }) => {
                  const serverConf = getServerConf(row)
                  if (serverConf.prefer_host) {
                    return `${this.$t('compute.text_111')}: ${row.hostInfo?.name || serverConf.prefer_host}`
                  }
                  if (serverConf.schedtags && row.schedtagInfo) {
                    const ret = [<div>{this.$t('compute.text_3')}</div>]
                    ret.push(...row.schedtagInfo.map(item => {
                      return <div>{item.schedtagObj?.name}{item.strategy ? ` ${this.$te(`schedtagPolicys.${item.strategy}`) ? this.$t(`schedtagPolicys.${item.strategy}`) : item.strategy}` : ''}</div>
                    }))
                    return ret
                  }
                  return '-'
                },
              },
            },
            {
              field: 'duration',
              title: i18n.t('common_435'),
              formatter: ({ row }) => {
                const serverConf = getServerConf(row)
                const durationUnit = {
                  h: i18n.t('common_11'),
                  w: i18n.t('common_417'),
                  d: i18n.t('common_12'),
                  m: i18n.t('common_13'),
                  y: i18n.t('common_14'),
                }
                if (serverConf.duration) {
                  const duration = parseInt(serverConf.duration)
                  const unit = serverConf.duration.substr(-1)
                  return i18n.t('common_436', [duration, durationUnit[unit.toLowerCase()]])
                }
                return '-'
              },
            },
          ],
        },
      ]
      const serverConf = getServerConf(this.detailsData)
      const containers = serverConf.pod?.containers || serverConf.containers || []
      if (!containers.length) {
        containerInfo.push({
          title: this.$t('compute.eci.container_config'),
          items: [
            {
              field: 'containers',
              title: this.$t('compute.eci.container_config'),
              formatter: () => '-',
            },
          ],
        })
      } else {
        containers.forEach((item, idx) => {
          const nameSuffix = item.name ? `（${item.name}）` : ''
          const title = containers.length > 1
            ? `${this.$t('compute.eci.container_config')} - ${this.$t('compute.container', [idx + 1])}${nameSuffix}`
            : this.$t('compute.eci.container_config')
          containerInfo.push({
            title,
            items: this.getContainerConfigItems(item, idx),
          })
        })
      }
      this.extraInfo.push(...containerInfo)
    },
    getContainerConfigItems (item, idx) {
      const boolText = (val) => (val ? this.$t('common.true') : this.$t('common.false'))
      const formatList = (list) => {
        const vals = (list || []).filter(Boolean)
        return vals.length ? vals.join('、') : '-'
      }
      const envsText = (item.envs || []).length
        ? item.envs.map(env => `${env.key}=${env.value}`).join('、')
        : '-'
      const volumeMountsText = (item.volume_mounts || []).length
        ? item.volume_mounts.map((vm) => {
          const diskIdx = vm.disk?.index
          const path = vm.mount_path || '-'
          const diskLabel = diskIdx === undefined || diskIdx === null
            ? '-'
            : `${this.$t('compute.text_376')}${Number(diskIdx) + 1}`
          return `${diskLabel}:${path}`
        }).join('、')
        : '-'
      const devicesText = (item.devices || []).length
        ? item.devices.map((dev, i) => {
          const deviceIdx = dev.isolated_device?.index
          return deviceIdx === undefined || deviceIdx === null
            ? `${this.$t('compute.text_113')}${i + 1}`
            : `${this.$t('compute.text_113')}${Number(deviceIdx) + 1}`
        }).join('、')
        : '-'
      const prefix = `container_${idx}`
      const items = [
        { field: `${prefix}_name`, title: this.$t('common.name'), formatter: () => item.name || '-' },
        { field: `${prefix}_image`, title: this.$t('compute.repo.container_image'), formatter: () => item.image || '-' },
        { field: `${prefix}_command`, title: this.$t('compute.repo.command'), formatter: () => formatList(item.command) },
        { field: `${prefix}_args`, title: this.$t('compute.repo.command.params'), formatter: () => formatList(item.args) },
        { field: `${prefix}_volume_mounts`, title: this.$t('compute.repo.data_volume'), formatter: () => volumeMountsText },
        { field: `${prefix}_envs`, title: this.$t('compute.repo.env_variables'), formatter: () => envsText },
        { field: `${prefix}_enable_lxcfs`, title: this.$t('compute.repo.enable_lxcfs'), formatter: () => boolText(!!item.enable_lxcfs) },
        { field: `${prefix}_privileged`, title: this.$t('compute.repo.privileged_mode'), formatter: () => boolText(!!item.privileged) },
        { field: `${prefix}_cap_add`, title: this.$t('compute.repo.capabilities.add'), formatter: () => formatList(item.capabilities?.add) },
        { field: `${prefix}_cap_drop`, title: this.$t('compute.repo.capabilities.drop'), formatter: () => formatList(item.capabilities?.drop) },
        { field: `${prefix}_devices`, title: this.$t('compute.text_113'), formatter: () => devicesText },
      ]
      if (item.rootfs) {
        items.push(
          { field: `${prefix}_rootfs`, title: this.$t('compute.repo.enable_sys_disk_overlay'), formatter: () => this.$t('common.true') },
          { field: `${prefix}_rootfs_persistent`, title: this.$t('compute.repo.rootfs_persistent'), formatter: () => boolText(!!item.rootfs.persistent) },
        )
      }
      return items
    },
  },
}
